
import { TranslationService } from "@app/services/translation.service";
import { IVehicle } from "@interfaces/IVehicle";
import { DynamicReportService } from "@reports/_services/dynamicReports.service";
import { IReportDefinition } from "@reports/models/IReportDefinition";
import { GroupService } from "@services/group.service.ajs";
import { NavigationService } from "@services/navigation.service";
import { VehicleService } from "@services/vehicle.service";
import { WebSocketService } from "@services/websocket.service";
import { StateService } from "@uirouter/angularjs";
import * as angular from "angular";
import * as moment from "moment";
import { SessionService } from "../../../services/session.service";
import { IGroup } from "../resourceManagement/groups/_models/IGroup";
import "./diagnostics.scss";
import { IWebSocketStatus } from "./diagnostics.service";

interface IWebsocketData {
    id: string;
    utc: moment.Moment;
    text: string;
}

export class DiagnosticsController {
    intervalPromise: angular.IPromise<any>;
    webSocketStatus: IWebSocketStatus[];

    videoSourceUrl: string;
    tempVideoSourceUrl: string;

    playbackSourceUrl: string;
    tempPlaybackSourceUrl: string;

    loading = false;
    websocketRawDataList: IWebsocketData[] = [];
    vehicles: IVehicle[] = [];
    groups: IGroup[] = [];

    commissionDiagnosticsVehicleId: number = 91645;

    static $inject = ["$scope", "$state", "$window", "$interval", "vehicleService", "webSocketService", "dynamicReportService", "groupService", "navigationService", "sessionService", "translationService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $state: StateService,
        private readonly $window: angular.IWindowService,
        private readonly $interval: angular.IIntervalService,
        private readonly vehicleService: VehicleService,
        private readonly webSocketService: WebSocketService,
        private readonly reportService: DynamicReportService,
        private readonly groupService: GroupService,
        private readonly navigationService: NavigationService,
        private readonly sessionService: SessionService,
        private readonly translationService: TranslationService
    ) {
        this.updateData();

        this.$scope.$on("$onDestroy", () => {
            this.$onDestroy();
        });

        //this.showClientAccountStreamMappings = true;
    }

    $onInit() {
        this.intervalPromise = this.$interval(() => {
            //this.updateData();
        }, 5 * 1000);

        this.vehicleService.getVehicles({ includePeripheralMappings: true }).then(vehicles => {
            this.vehicles = vehicles;
        });

    }

    $onDestroy() {
        this.$interval.cancel(this.intervalPromise);
        this.webSocketService.unregisterListener("PlotDataStream");
    }

    enableTranslationsVisualizer(): void {
        this.translationService.enableVisualizer();
        this.$window.location.reload(true);
    }

    disableTranslationsVisualizer(): void {
        this.translationService.disableVisualizer();
        this.$window.location.reload(true);
    }

    enableDemoMode() {
        window.location.href = '/#demo';
    }

    enableConfigurableDashboards() {
        this.sessionService.toggleConfigurableDashboards(true);
    }

    streamVideo() {
        this.videoSourceUrl = this.tempVideoSourceUrl;
    }

    playbackVideo() {
        this.playbackSourceUrl = this.tempPlaybackSourceUrl;
    }

    stockReportDefinitions: IReportDefinition[];

    updateStockReports() {
        this.reportService.updateStockReports().then(stockReports => {
            this.stockReportDefinitions = stockReports;
        });
    }

    goToPlanning() {
        this.navigationService.goToPlanning();
    }

    // ---

    private updateData() {
        this.loading = true;

        this.groupService
            .getGroups()
            .then(groups => { this.groups = groups; })
            .finally(() => { this.loading = false; });

        //this.diagosticsService
        //    .getWebSocketStatus()
        //    .then(status => {
        //        this.webSocketStatus = status.list;
        //    });
    }
}
